module.exports = __webpack_public_path__ + "static/images/components/Nation/images/flag-all-poland.20cde1b0.png";


//////////////////
// WEBPACK FOOTER
// ./components/Nation/images/flag-all-poland.png
// module id = 2618
// module chunks = 11